import { Card, Grid, Typography } from "@mui/material";
import { React } from "react";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";

export default function PlayerCareerStatsReadOnly(props) {
  const { styles, data } = props;
  const useStyles = makeStyles((themes) => ({
    ...styles,
    table: {
      minWidth: 650,
    },
    selectTableCell: {
      width: 60,
    },
    tableCell: {
      width: 130,
      height: 40,
    },
    input: {
      width: 130,
      height: 40,
    },
    readonlyTextColor: {
      color: "#c8102e",
    },
  }));
  const classes = useStyles();
  return (
    <Card className={classes.cardStyle}>
      <Grid container>
        <Grid
          item
          lg={3}
          md={6}
          sm={6}
          xs={12}
          className={classes.sectionTitlePadding}
        >
          <Box display="flex" flexDirection="row" p={1}>
            <Typography
              noWrap
              variant={styles.gridSectionTitle.variant}
              className={classes.gridSectionTitle}
              mr={1}
            >
              Name:
            </Typography>
            <Typography
              noWrap
              variant={styles.gridSectionTitle.variant}
              className={classes.readonlyTextColor}
            >
              {data.playerReadonlyData && data.playerReadonlyData.playerName}
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          lg={3}
          md={6}
          sm={6}
          xs={12}
          className={classes.sectionTitlePadding}
        >
          <Box display="flex" flexDirection="row" p={1}>
            <Typography
              noWrap
              variant={styles.gridSectionTitle.variant}
              className={classes.gridSectionTitle}
              mr={1}
            >
              College or Club:
            </Typography>
            <Typography
              noWrap
              variant={styles.gridSectionTitle.variant}
              className={classes.readonlyTextColor}
              style={{ marginRight: "10px" }}
            >
              {data.playerReadonlyData && data.playerReadonlyData.collegeOrClub}
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          lg={3}
          md={6}
          sm={6}
          xs={12}
          className={classes.sectionTitlePadding}
        >
          <Box display="flex" flexDirection="row" p={1}>
            <Typography
              noWrap
              variant={styles.gridSectionTitle.variant}
              className={classes.gridSectionTitle}
              mr={1}
            >
              Team:
            </Typography>
            <Typography
              noWrap
              variant={styles.gridSectionTitle.variant}
              className={classes.readonlyTextColor}
            >
              {data.playerReadonlyData && data.playerReadonlyData.teamName}
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          lg={3}
          md={6}
          sm={6}
          xs={12}
          className={classes.sectionTitlePadding}
        >
          <Box display="flex" flexDirection="row" p={1}>
            <Typography
              noWrap
              variant={styles.gridSectionTitle.variant}
              className={classes.gridSectionTitle}
              mr={1}
            >
              Birth Place:
            </Typography>
            <Typography
              noWrap
              variant={styles.gridSectionTitle.variant}
              className={classes.readonlyTextColor}
            >
              {data.playerReadonlyData && data.playerReadonlyData.birthPlace}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
}
